import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'header-component',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
  })
export class HeaderComponent
{
    @Input() headerText: string;
    layoutCtrl = new FormControl('boxed');
    constructor(){}
}
